/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { Dispatch, SetStateAction, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { UpdateProfile } from "../../../modules/settings/core/_requests";
import { useAuth } from "../../../auth/core/Auth";

interface InsuranceModalProps {
  showModal: boolean;
  handleModal: () => void;
  setInsurance: Dispatch<SetStateAction<boolean | undefined>>;
}

const InsuranceModal: React.FC<InsuranceModalProps> = ({
  showModal,
  handleModal,
  setInsurance,
}) => {
  const { currentUser } = useAuth();
  const chefId = currentUser?.uuid;
  const [insurance, setInsurances] = useState<boolean | undefined>(undefined);
  const handleInsurance = () => {

    if (insurance === false) {
      window.open("https://get.fliprogram.com/flip_annual?partner=298d2b3b-dd49-4f72-8285-f24a17213152", "_blank");
      handleModal();
      return; // Exit the function to avoid further execution
    }
  
    const data = {
      is_insurance: insurance,
    };

    UpdateProfile(data, chefId).then((res) => {
      if (res?.status === true) {
        toast.success(res?.message, { autoClose: 6000 });
        setInsurance(insurance ? insurance : false);
        handleModal();
      }
    });
  };

  return (
    <div>
      <Modal show={showModal} className="p-10" onHide={handleModal}>
        <div className="w-250px w-lg-275px">
          {/* Title Section */}
          <div className="d-flex flex-column align-items-center rounded-top">
            <h3 className="fw-bold m-0 px-3 py-2">Insurance Confirmation</h3>
          </div>

          <div className="tab-content">
            <div className="scroll-y mh-50px my-1 px-8 p-3">
              <>
                <p className="fw-semibold text-center mb-4">
                Do you currently have insurance coverage? If not, we partner with leading insurance providers to offer you a comprehensive insurance policy.
                </p>

                <div className="d-flex justify-content-center gap-3 mb-4">
                  <input
                    type="radio"
                    id="true"
                    name="insurance"
                    checked={insurance === true}
                    onChange={() => setInsurances(true)}
                  />
                  <label
                    htmlFor="true"
                  >
                    Yes
                  </label>

                  <input
                    type="radio"
                    id="false"
                    name="insurance"
                    checked={insurance === false}
                    onChange={() => setInsurances(false)}
                  />
                  <label
                    htmlFor="false"
                  >
                    No
                  </label>
                </div>
              </>
            </div>
          </div>

          <Modal.Footer className="pe-0 pb-0 mt-4">
            <Button
              className="btn btn-success rounded-5 me-2 mt-1"
              onClick={handleInsurance}
            >
              Submit
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
};

export default InsuranceModal;
